export default "__VITE_ASSET__CoyqCdnI__"